import estyled from '@signal/theme/emotion'
import { getSpacingSelector } from '@signal/theme'
import DesktopEmptyScreen from '../DesktopEmptyScreen'

export const Wrapper = estyled.div`
  display: flex;
  width: 100%;
  height: calc(100vh - 60px);
  justify-content: center;
  align-items: center;
`
export const EmptyScreen = estyled(DesktopEmptyScreen)`
  background: none;
`

export const ComponentWrapper = estyled.div`
  padding: ${getSpacingSelector(5)}px;
  margin: auto;
  max-width: 600px;
`
